import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-me-agreement',
  templateUrl: './me-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MeAgreementComponent extends AgreementsDateBaseDirective {
}
